module.exports = __webpack_public_path__ + "img/80D.45b1036f.png";